module.exports = __webpack_public_path__ + "static/media/arrow.1cad89b7.svg";